import Vue from "vue"
import {Component} from "vue-property-decorator"
import {Dimension, MemberDimension, Metric} from "@/cube"
import _ from "lodash"

@Component
export class WithAnalyticsNavigation extends Vue {
  protected goToAnalytics(
    metric: Metric,
    dimension: {[K in Dimension]?: unknown} | Dimension
  ): void {
    setTimeout(async () => {
      let query
      if (typeof dimension === "string") {
        query = {dimensions: dimension}
      } else {
        query = _.isEmpty(dimension)
          ? {dimensions: MemberDimension.gender}
          : // Use first element of keys array as only one filter is allowed
            {dimensions: [Object.keys(dimension)[0]]}
      }
      await this.$router.push({
        path: `/super/analytics/${metric}`,
        query,
      })
    }, 150)
  }
}
